import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16b43de9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { style: {"margin-left":"10px"} }
const _hoisted_3 = { class: "secondMenu" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-app" }, null, -1))
const _hoisted_6 = { style: {"margin-left":"10px"} }
const _hoisted_7 = {
  key: 0,
  class: "iconfont icon-jinrujiantou",
  style: {"margin-left":"50px"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  class: "navs",
  style: {"position":"fixed","margin-left":"310px"}
}
const _hoisted_11 = { class: "tab_con" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("关闭所有标签")
const _hoisted_13 = { style: {"padding":"24px","margin-left":"310px","margin-top":"35px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Headers = _resolveComponent("Headers")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "layout_content" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, { class: "lay_header" }, {
        default: _withCtx(() => [
          _createVNode(_component_Headers)
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_sider, {
            width: "130",
            class: "lay_left",
            style: {"position":"fixed","z-index":"100"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menusList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["name", {active:_ctx.navId == item.meta.title}]),
                    onClick: ($event: any) => (_ctx.changeNav(item))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass('iconfont '+_ctx.iconList[index])
                    }, null, 2),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(item.meta.title), 1)
                  ], 10, _hoisted_1)
                ]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_sider, {
            width: "180",
            class: "lay_left",
            style: {"background":"#fff","margin-top":"0","position":"fixed","margin-left":"130px","z-index":"100"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondMenu, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.changeRouter(item)),
                      class: _normalizeClass(["secondname", {active2: _ctx.secondId == item.meta.title}])
                    }, [
                      _hoisted_5,
                      _createElementVNode("span", _hoisted_6, _toDisplayString(item.meta.title), 1),
                      (item.children && item.children.length > 0)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_4),
                    (item.children && item.children.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (item2, index2) => {
                            return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["thirdName", {active2: _ctx.secondId == item2.meta.title}]),
                                onClick: ($event: any) => (_ctx.changeRouter2(item2))
                              }, _toDisplayString(item2.meta.title), 11, _hoisted_9)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_a_tabs, {
                    type: "editable-card",
                    "hide-add": "",
                    activeKey: _ctx.activeTabKey,
                    "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTabKey) = $event)),
                    size: "small",
                    style: {"width":"90%"},
                    onEdit: _ctx.removeTab,
                    onChange: _ctx.onTabChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabKeys, (item) => {
                        return (_openBlock(), _createBlock(_component_a_tab_pane, {
                          tab: item.name,
                          key: item.url,
                          closable: true
                        }, null, 8, ["tab"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["activeKey", "onEdit", "onChange"])
                ]),
                _createElementVNode("a", {
                  style: {"margin-left":"16px","position":"fixed","float":"right","right":"20px"},
                  size: "small",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeAllTabs && _ctx.closeAllTabs(...args)))
                }, [
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _hoisted_12
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_CloseOutlined, { style: {"color":"#999999"} })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_router_view)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}